module.exports = require("@swa-ui/personal-info/src/form/PassengerAccommodationsFormFields/PassengerAccommodationsFormFields.module.scss");